<template>
  <div class="d-flex flex-column flex-md-row">
    <div v-if="cafeVideoRoomMaster != null" class="cafe-container">
      <div class="cafe-overlay"/>
      <proa-heading sub class="mt-4 pt-3 mb-3 pb-1">{{ $t('pages.mySpace.cafe') }}</proa-heading>
      <div class="cafe-wrapper">
        <cafe-room-card :cafeRoom="cafeVideoRoomMaster"/>
      </div>
    </div>
    <div v-show="signedInUser.creatable" :class="['meeting-rooms-container', { 'no-cafe': !cafeVideoRoomMaster }]">
      <proa-heading sub class="mt-4 pt-3 mb-3 pb-1">{{ $t('pages.mySpace.meetingRooms') }}</proa-heading>
      <div v-if="$mq === 'sm'">
        <div v-if="!initialized" class="loading-wrapper">
          <proa-loading class="loading"/>
        </div>
        <div
          v-for="normalVideoRoomMaster in normalVideoRoomMasters"
          :key="normalVideoRoomMaster.id"
          class="mb-3"
        >
          <meeting-room-card :meetingRoom="normalVideoRoomMaster"/>
        </div>
      </div>
      <div v-else class="meeting-rooms-wrapper">
        <div v-if="!initialized" class="loading-wrapper">
          <proa-loading class="loading"/>
        </div>
        <carousel
         :mouse-drag="$deviceInfo.isMobile"
         :navigate-to="carousel.navigateTo"
         :per-page="carousel.perPage"
         :pagination-enabled="false"
         class="meeting-rooms-carousel"
         ref="meetingRoomsCarousel"
         @page-change="carouselPageChanged">
          <slide v-for="normalVideoRoomMaster in normalVideoRoomMasters" :key="normalVideoRoomMaster.id">
            <meeting-room-card :meetingRoom="normalVideoRoomMaster"/>
          </slide>
        </carousel>
        <div v-if="!$deviceInfo.isMobile" class="meeting-rooms-overlay">
          <div
            v-if="carouselBefore !== false"
            @click="onClickCarouselNavigation(carouselBefore)"
            class="meeting-rooms-carousel-navigation before"
          />
          <div
            v-if="carouselNext !== false"
            @click="onClickCarouselNavigation(carouselNext)"
            class="meeting-rooms-carousel-navigation next"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VideoRoomMaster from '@/store/models/VideoRoomMaster'
import { Carousel, Slide } from 'vue-carousel'
import MeetingRoomCard from '@/components/molecules/MeetingRoomCard'
import CafeRoomCard from '@/components/molecules/CafeRoomCard'

export default {
  name: 'MySpaceMeetingRooms',
  components: {
    Carousel,
    Slide,
    MeetingRoomCard,
    CafeRoomCard
  },
  computed: {
    carouselBefore: function() {
      if (this.carousel.index != 0) {
        return this.carousel.index - 1
      } else {
        return false
      }
    },
    carouselNext: function() {
      if ((this.carousel.index + 1) * this.carousel.perPage < this.normalVideoRoomMasters.length) {
        return this.carousel.index + 1
      } else {
        return false
      }
    },
    normalVideoRoomMasters: function() {
      if (!this.initialized) return []
      return VideoRoomMaster.query().where('roomType', 'normalRoom').orderBy('roomCapacity', 'desc').get()
    },
    cafeVideoRoomMaster: function() {
      if (!this.initialized) return null
      return VideoRoomMaster.query().where('roomType', 'cafeRoom').first()
    },
    ...mapGetters({
      signedInUser: 'auth/signedInUser'
    })
  },
  data(){
    return {
      initialized: false,
      carousel: {
        index: 0,
        perPage: 0,
        navigateTo: 0
      },
      videoRoomMastersReloadInterval: null
    }
  },
  methods: {
    handleResize: function() {
      if (!this.$refs.meetingRoomsCarousel) return
      this.carousel.perPage = Math.floor(this.$refs.meetingRoomsCarousel.$el.clientWidth / 260) || 1
    },
    carouselPageChanged: function(page) {
      this.carousel.index = Number.isFinite(page) ? page : 0
    },
    onClickCarouselNavigation: function(toPage) {
      this.carousel.navigateTo = toPage
    },
    ...mapActions({
      apiGetVideoRoomMasters: 'entities/videoRoomMasters/index'
    })
  },
  async created () {
    if (VideoRoomMaster.exists()) this.initialized = true

    await this.apiGetVideoRoomMasters()

    this.initialized = true
    this.$nextTick(() => {
      this.handleResize()
    })

    // NOTE: 10分に一度VideoRoomMastersを再取得
    this.videoRoomMastersReloadInterval = setInterval(() => {
      this.apiGetVideoRoomMasters()
    }, 600000)
  },
  mounted: function () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
    clearInterval(this.videoRoomMastersReloadInterval)
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/mediaquery";
@import "@/styles/variables";

.loading-wrapper {
  min-width: 260px;
  min-height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;

  .loading {
    width: 80px;
    height: 80px;
  }
}

.cafe-container {
  background: $background-color;
  z-index: 1;
  margin: -2px 0 -2px -40px;
  padding: 2px 0 2px 40px;
}

.cafe-wrapper {
  position: relative;
}

.meeting-rooms-container {
  @include mq(lg) {
    &:not(.no-cafe) {
      padding-left: 10px;
    }
  }

  &.no-cafe {
    .meeting-rooms-carousel {
      @include mq(md) {
        width: calc(100vw - 84px);
      }

      @include mq(lg) {
        width: calc(100vw - 240px);
      }
    }
  }
}

.meeting-rooms-wrapper {
  position: relative;
}

.meeting-rooms-carousel {
  @include mq(md) {
    width: calc(100vw - 354px);
  }

  @include mq(lg) {
    width: calc(100vw - 510px);
  }
}

.meeting-rooms-overlay {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;

  .meeting-rooms-carousel-navigation {
    width: 50px;
    height: 50px;
    background: $primary-color;
    opacity: 0.3;
    border-radius: 50%;
    cursor: pointer;
    pointer-events: auto;
    position: absolute;
    top: calc(50% - 25px);
    color: white;

    &:hover {
      opacity: 1;
    }

    &::before {
      content:  '';
      width: 12px;
      height: 12px;
      display:  block;
      border-top: solid 1px;
      border-right: solid 1px;
      position: absolute;
    }

    &.before {
      left: 20px;

      &::before {
        transform: rotate(225deg);
        top: calc(25px - 6px);
        left: calc(25px - 4px);
      }
    }

    &.next {
      right: 40px;

      &::before {
        transform: rotate(45deg);
        top: calc(25px - 6px);
        left: calc(25px - 9px);
      }
    }
  }
}
</style>
